export const NOME_TIPO: Record<string, string> = { condominio: 'Condomínio', empresa: 'Empresa', pessoa: 'Pessoa física' };
export const NOME_STATUS: Record<string, string> = { prospecto: 'Prospecto', ativo: 'Ativo', inativo: 'Inativo' };
export const NOME_PAPEL_CONTATO: Record<string, string> = {
  sindico: 'Síndico(a)', subsindico: 'Subsíndico(a)', zelador: 'Zelador(a)', administradora: 'Administradora',
  gerente_predial: 'Gerente predial', financeiro: 'Financeiro', ronda: 'Ronda', outro: 'Outro',
};

export function telefone(t: string | null): string {
  if (!t) return '—';
  const d = t.replace(/^55/, '');
  return d.length === 11 ? `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}` : d.length === 10 ? `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}` : t;
}

export function endereco(l: { logradouro: string | null; numero: string | null; bairro: string | null; cidade: string | null; uf: string | null }): string {
  const linha1 = [l.logradouro, l.numero].filter(Boolean).join(', ');
  const linha2 = [l.bairro, [l.cidade, l.uf].filter(Boolean).join('/')].filter(Boolean).join(' · ');
  return [linha1, linha2].filter(Boolean).join(' — ') || 'Endereço não informado';
}

/** "−22,7253, −47,6476" ou "-22.7253 -47.6476" (copiado do Google Maps) → números */
export function lerCoordenadas(texto: string): { latitude: number; longitude: number } | null {
  const nums = texto.replace(/,(?=\d)/g, '.').match(/-?\d+(\.\d+)?/g);
  if (!nums || nums.length !== 2) return null;
  const [latitude, longitude] = nums.map(Number) as [number, number];
  if (Math.abs(latitude) > 90 || Math.abs(longitude) > 180) return null;
  return { latitude, longitude };
}

export function tiposDe<T extends string>(mapa: Record<T, string>) {
  return Object.entries(mapa) as [T, string][];
}
